import lightningFastInfoRetrievalIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/lightning-fast-info-retrieval.svg';
import significantProductivityGainsIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/significant-productivity-gains.svg';
import reducedAiHallucinationsIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/reduced-ai-hallucinations.svg';
import betterDecisionMakingIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/better-decision-making.svg';
import enterpriseGradeSecurityIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/enterprise-grade-security.svg';
import fullOwnershipIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/full-ownership.svg';

export const searchDatabaseData = [
  {
    title: 'Lighting-Fast Info Retrieval',
    description:
      'Cut information search time by 40-70%. What used to take 45 minutes now takes seconds. Your teams get instant answers pulled from verified sources across your entire knowledge base.',
    icon: lightningFastInfoRetrievalIcon,
  },
  {
    title: 'Significant Productivity Gains',
    description:
      'Your employees will be significantly more creative and productive without the hassle of manually searching for the information they need. That’s a promise.',
    icon: significantProductivityGainsIcon,
  },
  {
    title: 'Reduced AI Hallucinations',
    description:
      'Get accurate, grounded responses backed by your actual documents. No more fabricated information that sounds convincing but is completely wrong.',
    icon: reducedAiHallucinationsIcon,
  },
  {
    title: 'Better Decision-Making',
    description:
      'Reduce information gaps in critical decisions by 40-60%. Leaders get comprehensive, contextual information at the moment of need.',
    icon: betterDecisionMakingIcon,
  },
  {
    title: 'Enterprise-Grade Security',
    description:
      'Maintain complete data sovereignty with on-premises deployment. Your sensitive information never leaves your infrastructure - no external APIs, no cloud dependencies.',
    icon: enterpriseGradeSecurityIcon,
  },
  {
    title: 'Full Ownership, Zero Lock-In',
    description:
      'You own what we build. The entire solution - source code, models, infrastructure. If privacy and security are crucial to you, your own solution is a must - eliminate vendor lock-in with our experts.',
    icon: fullOwnershipIcon,
  },
];
